/**
 * Maps an employee record to a role variant string used for accent + chip styling.
 * Variants: 'owner' | 'employee' | 'contractor' | 'invited' | 'role'
 *
 * Why 'role' is separate: a custom team role (e.g. "Site Foreman" from team_roles
 * table) gets a neutral sky-blue accent so we don't pretend it's the same as the
 * built-in Owner/Employee variants.
 */
export function getRoleVariant(employee) {
  if (!employee) return "employee";
  if (employee.status === "invited") return "invited";
  if (employee.kind === "ghost") return "contractor";
  const perms = employee.permissions || [];
  if (perms.includes("manage_company_settings")) return "owner";
  if (employee.role_name) return "role";
  return "employee";
}

export function getRoleLabel(employee, variant) {
  const v = variant || getRoleVariant(employee);
  if (v === "invited") return "Invited";
  if (v === "contractor") return "Contractor";
  if (v === "owner") return "Owner";
  if (v === "role") return employee?.role_name || "Employee";
  return "Employee";
}
